import US from 'img/us.png'
import ES from 'img/es.png'
import CN from 'img/cn.png'
import FR from 'img/fr.png'
import HI from 'img/in.png'
import JO from 'img/jo.png'
import HEAT_MAP from 'img/thermal.png'
import TERRAIN_LAYER from 'img/graphic-layer.png'
import SATELITE_LAYER from 'img/satelite-layer.png'
import TRIAL_IMG_ASSET from 'img/trial-img.png'
import OPEN_STREET_LAYER from 'img/openstreetmap.jpg'
import GOOGLE_ROADMAP_LAYER from 'img/Googleroadmap.png'
import GOOGLE_SATELLITE_LAYER from 'img/Google satellite.jpg'
import GOOGLE_HYBRID_LAYER from 'img/Google hybrid.jpg'
import GOOGLE_TERRAIN_LAYER from 'img/Terrain-Maps-New-Mexico.jpg'
import UPGRADE_BG_1_ASSET from 'img/upgrade_bg_1.png'
import UPGRADE_BG_2_ASSET from 'img/upgrade_bg_2.png'

export const FLAG_IMAGES = {
  US,
  ES,
  CN,
  FR,
  HI,
  JO
}

export const MAP_SETTINGS_IMAGES = {
  HEAT_MAP,
  TERRAIN_LAYER,
  SATELITE_LAYER,
  OPEN_STREET_LAYER,
  GOOGLE_ROADMAP_LAYER,
  GOOGLE_SATELLITE_LAYER,
  GOOGLE_HYBRID_LAYER,
  GOOGLE_TERRAIN_LAYER
}

export const TRIAL_IMG = TRIAL_IMG_ASSET
export const UPGRADE_BG_1 = UPGRADE_BG_1_ASSET
export const UPGRADE_BG_2 = UPGRADE_BG_2_ASSET
